import getAuth0 from './client';
import * as routes from '../../routes/const';

export default async function auth0Logout(isSilent) {
  const auth0 = await getAuth0();

  if (isSilent) {
    const url = auth0.buildLogoutUrl();
    await auth0.logout({ localOnly: true });

    // Inform Auth0 to clear up the session based on cookies
    return fetch(url, { method: 'GET', credentials: 'include' });
  }

  return auth0.logout({
    returnTo: `${window.location.origin}${routes.CompleteAuth0Logout}`
  });
}



// WEBPACK FOOTER //
// ./src/utils/auth0/logout.js